import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../../../Apicongfig";
import { useTranslation } from "react-i18next";
import { Editor } from "@tinymce/tinymce-react";
import Select from "react-select";
import { toast } from "react-toastify";
import { useFormContext } from "../../../../../context/CreateMeetingContext";
import { Button, Spinner } from "react-bootstrap";
import cheerio from "cheerio";
import { useMeetings } from "../../../../../context/MeetingsContext";
import moment from "moment";

function extractBase64SrcFromHTML(htmlString) {

  const base64SrcArray = [];

  // Load the HTML string into cheerio
  const $ = cheerio.load(htmlString);

  // Find all elements with 'src' attribute
  $("[src]").each((index, element) => {
    const srcValue = $(element).attr("src");

    // Check if the src starts with 'data:image'
    if (srcValue && srcValue?.startsWith("data:image")) {
      // If src is a base64 image, push it into base64SrcArray
      base64SrcArray.push(srcValue);
    }
  });

  return base64SrcArray;
}
function replaceBase64SrcWithLinks(htmlString, imageLinks) {
  // Load the HTML string into cheerio
  const $ = cheerio.load(htmlString);

  // Find all elements with 'src' attribute
  $("[src]").each((index, element) => {
    const srcValue = $(element).attr("src");

    // Check if the src starts with 'data:image'
    if (srcValue && srcValue?.startsWith("data:image")) {
      // Replace the src with the corresponding link from imageLinks
      $(element).attr("src", imageLinks[index]);
    }
  });

  // Return the modified HTML string
  return $.html();
}
// export const optimizeEditorContent = async (editorContent) => {
//   if (!editorContent) return "";

//   const base64Array = extractBase64SrcFromHTML(editorContent);
//   if (base64Array.length === 0) {
//     return editorContent;
//   }

//   const cloudinaryUploads = base64Array.map(async (base64Image) => {
//     try {
//       const response = await fetch("https://api.cloudinary.com/v1_1/drrk2kqvy/upload", {
//         method: "POST",
//         body: JSON.stringify({
//           file: base64Image,
//           upload_preset: "chat-application",
//         }),
//         headers: {
//           "Content-Type": "application/json",
//         },
//       });
//       const data = await response.json();
//       return data.secure_url;
//     } catch (error) {
//       console.error("Error uploading image to Cloudinary:", error);
//       return null;
//     }
//   });

//   const uploadedImageUrls = await Promise.all(cloudinaryUploads);
//   const filteredUrls = uploadedImageUrls.filter((url) => url !== null);

//   console.log('filterUrls',filteredUrls)
//   return replaceBase64SrcWithLinks(editorContent, filteredUrls);
// };


const MomentDetail = ({ setActiveTab }) => {
  const APIKEY = process.env.REACT_APP_TINYMCE_API;
  const {
    formState,
    setFormState,
    handleInputBlur,
    meeting,
    getMeeting,
    checkId,
    isUpdated,
    isDuplicate,
    handleCloseModal,
    fromDestination,
    fromDestinationName,
    recurrentMeetingAPI,
    changePrivacy,
    changeContext
  } = useFormContext();
  const { getMeetings } = useMeetings();
  const [t] = useTranslation("global");
  const [objectives, setObjectives] = useState([]);
  const [options, setOptions] = useState([]);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const userId = sessionStorage.getItem("user_id");
  const [loading, setLoading] = useState(false); // Loading state
  const [loadingQuit, setLoadingQuit] = useState(false);
  const [userTime, setUserTime] = useState(null);
  const [timeDifference, setTimeDifference] = useState(null);


    const editorRef = useRef(null);
  const [content, setContent] = useState('');

const [modifiedFileText, setModifiedFileText] = useState();  
  //  const handleContentOptimization = async (content) => {
  //   const optimizedEditorContent = await optimizeEditorContent(content);
  //   setFormState(prev => ({...prev, description: optimizedEditorContent}));
  // };
  const optimizeEditorContent = async (editorContent) => {
    if (!editorContent) {
      return "";
      //-------- CLOUD LOGIC ------------------------------
    }
    let optimizedEditorContent = "";
    const base64Array = extractBase64SrcFromHTML(editorContent);
    if (!base64Array.length > 0) {
      optimizedEditorContent = editorContent;
      return optimizedEditorContent;
    } else {
      const cloudinaryUploads = base64Array.map(async (base64Image) => {
        try {
          const response = await fetch(
            "https://api.cloudinary.com/v1_1/drrk2kqvy/upload",
            {
              method: "POST",
              body: JSON.stringify({
                file: base64Image,
                upload_preset: "chat-application",
              }),
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          const data = await response.json();

          return data.secure_url;
        } catch (error) {
          console.error("Error uploading image to Cloudinary:", error);
          return null;
        }
      });

      const uploadedImageUrls = await Promise.all(cloudinaryUploads);
      const editorContentWithCloudLinks = replaceBase64SrcWithLinks(
        editorContent,
        uploadedImageUrls
      );

      optimizedEditorContent = editorContentWithCloudLinks;
      return optimizedEditorContent;
    }

    // // ------- CLOUD LOGIC END -------------------------
  };

  useEffect(() => {
    getObjectives();
  }, []);
  useEffect(() => {
    if (checkId) {
      if (changePrivacy) return;

      getMeeting(checkId);
    }
  }, [checkId]);

  const lowerCasedObjectives = objectives?.map((obj) => {
    if (obj) {
      return {
        name: obj?.toLowerCase(),
      };
    }
    return null;
  });
  const [value, setValue] = useState("");

  useEffect(() => {
    if (meeting) {
      const objectiveValue =
        fromDestination && fromDestinationName
          ? fromDestinationName
          : meeting.objective || "";

      setFormState((prevState) => ({
        ...prevState,
        objective: objectiveValue, // Always set the correct objective
        title: meeting.title || "",
        priority: meeting.priority || "",
        description: meeting.description || "",
      }));
      setModifiedFileText(meeting?.description)
      setContent(meeting?.description || '');

      setValue(objectiveValue);

      // Ensure the objective exists in dropdown options
      if (
        objectiveValue &&
        !options.some((opt) => opt.value === objectiveValue)
      ) {
        setOptions((prevOptions) => [
          ...prevOptions,
          { value: objectiveValue, label: objectiveValue },
        ]);
      }
    }
  }, [meeting, fromDestination, fromDestinationName, setFormState]);

  useEffect(() => {
    if (fromDestinationName) {
      setValue(fromDestinationName);
      setFormState((prevState) => ({
        ...prevState,
        objective: fromDestinationName,
      }));
    }
  }, []);
  const getObjectives = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/get-objectives/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (response.status) {
        const objectives = response?.data?.data;
        setObjectives(objectives);
        const newOptions = objectives.map((item) => ({
          value: item,
          label: item,
        }));
        setOptions(newOptions);
      }
    } catch (error) {}
  };

  const handleEditorChange = (content) => {
    setContent(content);
  };

  const uploadToCloudinary = async (blobInfo) => {
    return new Promise(async (resolve, reject) => {
      try {
        const formData = new FormData();
        formData.append('file', blobInfo.blob(), blobInfo.filename());
        formData.append('upload_preset', 'chat-application'); // Replace with your upload preset
        formData.append('cloud_name', 'drrk2kqvy'); // Replace with your cloud name

        const response = await fetch(
          `https://api.cloudinary.com/v1_1/drrk2kqvy/image/upload`,
          {
            method: 'POST',
            body: formData,
          }
        );

        if (!response.ok) {
          throw new Error('Upload failed');
        }

        const data = await response.json();
        resolve(data.secure_url); // Return the secure URL from Cloudinary
      } catch (error) {
        console.error('Upload error:', error);
        reject('Image upload failed: ' + error.message);
      }
    });
  };


  const validateForm = () => {
    let validationErrors = {};
    let errorMessage = "";

    // if (!formState.objective) {
    //   validationErrors.objective = t("meeting.formState.destination");
    //   if (!errorMessage) errorMessage = validationErrors.objective;
    // }
    if (!formState.title) {
      validationErrors.title = t("meeting.formState.title");
      if (!errorMessage) errorMessage = validationErrors.title;
    }
    // if (!formState.priority) {
    //   validationErrors.priority = t("meeting.formState.priority");
    //   if (!errorMessage) errorMessage = validationErrors.priority;
    // }

    setErrors(validationErrors);

    if (errorMessage) {
      toast.error(errorMessage.trim());
    }

    return Object.keys(validationErrors).length === 0;
  };

  const handleSaveAndContinue = async () => {
    if (validateForm()) {

// 1. First optimize the content (upload images to S3)
      const optimizedContent = await optimizeEditorContent(modifiedFileText);
      
      // 2. Update the state with optimized content
      // setModifiedFileText(optimizedContent);
      setLoading(true); // Show loader
      await new Promise((resolve) => setTimeout(resolve, 0));

      try {
        const options = { updatedButton: false, quitAndUpdate: false };
            const newformState = { 
          ...formState, 
          description: content,
          // objective: formState.objective,
          title: formState.title,
          priority: formState.priority|| ""
        };
        await handleInputBlur(newformState, options);
        if(changeContext){
          handleCloseModal()
        }
        meeting?.solution || meeting?.type === "Google Agenda Event"
          ? setActiveTab("tab3")
          : setActiveTab("tab3");
      } catch (error) {
        // Handle error (if any)
        toast.error("Error occurred");
      } finally {
        setLoading(false); // Hide loader
      }
    }
  };

  useEffect(() => {
    const currentTime = moment().startOf("minute"); // Normalize to remove seconds
    setUserTime(currentTime);
  }, []);

  // Calculate the time difference when userTime or meeting details change
  useEffect(() => {
    if (userTime && meeting?.date && meeting?.start_time) {
      const meetingTime = moment(
        `${meeting?.date} ${meeting?.start_time}`,
        "YYYY-MM-DD HH:mm:ss"
      ).startOf("minute"); // Normalize meeting time to remove seconds

      if (meetingTime.isValid()) {
        const diff = meetingTime.diff(userTime, "minutes");
        setTimeDifference(diff);
      } else {
        console.error("Invalid meeting date or time format.");
        setTimeDifference(null); // Reset to null if invalid
      }
    }
  }, [userTime, meeting]);

  const handleSaveAndQuit = async () => {
    if (
      formState?.note_taker == true &&
      meeting?.location === "Google Meet" &&
      timeDifference !== null &&
      timeDifference < 30
    ) {
      toast.warning(t("UpmeetWarning"));
      return;
    }

    if (validateForm()) {
      setLoadingQuit(true); // Show loader
      await new Promise((resolve) => setTimeout(resolve, 0));

      try {
         // 1. Optimize content (upload images)
    const optimizedContent = await optimizeEditorContent(modifiedFileText);
    
    // // 2. Update state (wait for it if needed)
    // await new Promise(resolve => {
    //   setModifiedFileText(optimizedContent);
    //   resolve();
    // });

    // 3. Prepare and save data
    const options = { updatedButton: true, quitAndUpdate: true };
    const newformState = { 
      ...meeting, 
      description: content,
      objective: formState.objective,
      title: formState.title,
      priority: formState.priority|| ""
    };
        await handleInputBlur(newformState, options);
        recurrentMeetingAPI();
        // setActiveTab("tab2");
        handleCloseModal();
        navigate(`/invite/${checkId}`, { state: { from: "meeting" } });
      } catch (error) {
        // Handle error (if any)
        toast.error("Error occurred");
      } finally {
        setLoadingQuit(false); // Hide loader
        await getMeetings();
      }
    }
  };

  const priorityOptions = [
    // { value: "", label: t("meeting.newMeeting.options.priorities.priority") },
    {
      value: "Obligatoire",
      label: t("meeting.newMeeting.options.priorities.Obligatoire"),
    },
    {
      value: "Majeure",
      label: t("meeting.newMeeting.options.priorities.Majeure"),
    },
    {
      value: "Moyenne",
      label: t("meeting.newMeeting.options.priorities.Moyenne"),
    },
    {
      value: "Mineure",
      label: t("meeting.newMeeting.options.priorities.Mineure"),
    },
    {
      value: "Secondary",
      label: t("meeting.newMeeting.options.priorities.Secondary"),
    },
  ];

  return (
    <>
      <div className="col-md-12 modal-height">
        <div className="create-moment-modal">
          <div className="row form">
            {/* <div
              className="mb-2 col-lg-6 col-sm-12"
              style={{ position: "relative", zIndex: 3 }}
            >
              <label className="form-label">
                {t("Destination")}{" "}
                <small style={{ color: "red", fontSize: "15px" }}>*</small>{" "}
              </label>

              <Select
                className="my-select destination-select-dropdown"
                classNamePrefix="select"
                
                isDisabled={fromDestination} // Disable if fromDestination is true
                onChange={(option) => {
                  const selectedValue = option ? option.value : null;

                  if (
                    selectedValue &&
                    !options.find((opt) => opt.value === selectedValue)
                  ) {
                    setOptions((prevOptions) => [
                      ...prevOptions,
                      { value: selectedValue, label: selectedValue },
                    ]);
                  }

                  setFormState((prevState) => ({
                    ...prevState,
                    objective: selectedValue,
                  }));

                  setValue(selectedValue);
                }}
                onBlur={handleInputBlur}
                value={
                  formState.objective
                    ? options.find(
                        (opt) => opt.value === formState.objective
                      ) || {
                        value: formState.objective,
                        label: formState.objective,
                      }
                    : null
                }
                options={options}
                isClearable
              />
            </div> */}
            <div className="mb-2 col-lg-6 col-sm-12">
              <label className="form-label">
                {t("Objective")}{" "}
                <small style={{ color: "red", fontSize: "15px" }}>*</small>
              </label>
              <input
                type="text"
                required
                className="form-control"
                value={formState.title}
                onChange={(e) =>
                  setFormState((prevState) => ({
                    ...prevState,
                    title: e.target.value,
                  }))
                }
                // onBlur={handleInputBlur}
                placeholder={t("meeting.newMeeting.placeholders.objective")}
              />
            </div>
          </div>
          {/* <div
            className="col-lg-12 form row"
            style={{ position: "relative", zIndex: 2 }}
          >
            <div className="mb-2 col-md-6" style={{ paddingRight: "0" }}>
              <label className="form-label">
                {t("meeting.newMeeting.labels.priority")}
                <small style={{ color: "red", fontSize: "15px" }}>*</small>
              </label>
              <Select
                className="my-select destination-select-dropdown"
                classNamePrefix="select"
                value={
                  priorityOptions.find(
                    (option) => option.value === formState.priority
                  ) || null
                }
                onChange={(selectedOption) => {
                  const selectedValue = selectedOption
                    ? selectedOption.value
                    : "";
                  setFormState((prevState) => ({
                    ...prevState,
                    priority: selectedValue,
                  }));
                }}
                options={priorityOptions}
                isClearable
                // onBlur={handleInputBlur}
              />
            </div>
          </div> */}
          <div
            className="col-lg-12 form d-flex gap-2"
            style={{ position: "relative", zIndex: 1 }}
          >
            <div className="mb-2 col-md-12">
              <label className="form-label">
                {t("meeting.newMeeting.labels.context")}
                {/* <small style={{ color: "red", fontSize: "15px" }}>*</small> */}
              </label>
              {/* <Editor
                value={modifiedFileText}
                apiKey={APIKEY}
                className= "moment-description-editor"
                name="text"
                init={{
                  statusbar: false,
                  branding: false,
                  height: 300,
                  menubar: true,
                  language: "fr_FR",
                  // language: "en_EN",
                  plugins:
                    "print preview paste searchreplace autolink directionality visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern",
                  toolbar:
                    "formatselect | bold italic underline strikethrough | forecolor backcolor blockquote | image | imagePicker link media | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | removeformat",
                  image_advtab: true,
                  file_picker_types: "image media",

                  file_picker_callback: function (callback, value, meta) {
                    if (meta.filetype === "image") {
                      const input = document.createElement("input");
                      input.setAttribute("type", "file");
                      input.setAttribute("accept", "image/*");

                      input.onchange = function () {
                        const file = input.files[0];
                        const reader = new FileReader();

                        reader.onload = function (e) {
                          const img = new Image();
                          img.src = e.target.result;

                          img.onload = function () {
                            const canvas = document.createElement("canvas");
                            const ctx = canvas.getContext("2d");
                            const maxWidth = 700;
                            const maxHeight = 394;

                            let newWidth = img.width;
                            let newHeight = img.height;

                            if (img.width > maxWidth) {
                              newWidth = maxWidth;
                              newHeight = (img.height * maxWidth) / img.width;
                            }

                            if (newHeight > maxHeight) {
                              newHeight = maxHeight;
                              newWidth = (img.width * maxHeight) / img.height;
                            }

                            canvas.width = newWidth;
                            canvas.height = newHeight;

                            ctx.drawImage(img, 0, 0, newWidth, newHeight);

                            const resizedImageData = canvas.toDataURL(
                              file.type
                            );

                            // Pass the resized image data to the callback function
                            callback(resizedImageData, {
                              alt: file.name,
                            });
                          };

                          img.src = e.target.result;
                        };

                        reader.readAsDataURL(file);
                      };

                      input.click();
                    }
                      },
                              setup: (editor) => {
                                // Disable pasting images and media
                                editor.on("paste", (event) => {
                                  if (meeting?.type === "Law") {
                                    const clipboard =
                                      event.clipboardData ||
                                      window.clipboardData;
                                    const items = clipboard.items || [];
                                    for (const item of items) {
                                      if (
                                        item.type.startsWith("image") ||
                                        item.type.startsWith("video")
                                      ) {
                                        event.preventDefault();
                                        console.warn(
                                          "Pasting images and videos is not allowed for 'Law' type content."
                                        );
                                        return;
                                      }
                                    }
                                  }
                                });
                  },
                }}
              onEditorChange={(content) => {
    setModifiedFileText(content);
  }}
              /> */}
               <Editor
        apiKey={APIKEY}
        onInit={(evt, editor) => (editorRef.current = editor)}
        value={content}
        onEditorChange={handleEditorChange}
        init={{
                  height: 300,
                  menubar: true,
                  plugins: [
                    "advlist autolink lists link image charmap print preview anchor",
                    "searchreplace visualblocks code fullscreen",
                    "insertdatetime media table paste code help wordcount",
                    "image",
                    "imagetools",
                  ],
                  toolbar:
                    "undo redo | formatselect | bold italic underline | \
                  alignleft aligncenter alignright alignjustify | \
                  bullist numlist outdent indent | link image | \
                  code | fullscreen | help",

                  /* Cloudinary Image Handling */
                  automatic_uploads: true,
                  images_upload_handler: async (blobInfo, progress) => {
                    progress(0);
                    try {
                      const url = await uploadToCloudinary(blobInfo);
                      progress(100);
                      return url;
                    } catch (error) {
                      progress(0);
                      throw error;
                    }
                  },

                  /* Enable all image input methods */
                  paste_data_images: true,
                  file_picker_types: "image",

                  /* Image enhancements */
                  image_caption: true,
                  image_advtab: true,
                  image_title: true,


    // 🟢 Enable resizing images with the mouse
  resize_img_proportional: true, // Optional: constrain proportions
object_resizing: true, // or 'img' to target only images
image_dimensions: true, // shows width/height fields and supports inline sizing


                  image_class_list: [
                    { title: "Responsive", value: "img-responsive" },
                    { title: "Rounded", value: "img-rounded" },
                  ],

                  /* Responsive images by default */
                  content_style: `
                 
                  img.img-rounded { border-radius: 8px; }
                `,
                }}
      />
            </div>
          </div>
        </div>

        {/* <div
          className={`modal-footer px-4 d-flex justify-content-end modal-save-button gap-4`}
        >
          {(isUpdated || isDuplicate) && (
            <Button
              variant="danger"
              // className="btn "
              onClick={handleSaveAndQuit}
              disabled={loadingQuit}
              style={{ padding: "9px" }}
            >
              {loadingQuit ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    style={{
                      textAlign: "center",
                      fontWeight: "600",
                      fontSize: "16px",
                      color: "white",
                      margin: "5px 82px",
                    }}
                  />
                </>
              ) : (
                <>&nbsp;{t("meeting.formState.Save and Quit")}</>
              )}
            </Button>
          )}
          <button
            className="btn moment-btn"
            onClick={handleSaveAndContinue}
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  style={{
                    textAlign: "center",
                    fontWeight: "600",
                    fontSize: "16px",
                    color: "white",
                    margin: "5px 82px",
                  }}
                />
              </>
            ) : (
              <>
                &nbsp;{changeContext ? t("Validate") :t("meeting.formState.Save and Continue")}
                <span>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.4707 8.52991C13.397 8.46125 13.3379 8.37845 13.2969 8.28645C13.2559 8.19445 13.2338 8.09513 13.2321 7.99443C13.2303 7.89373 13.2488 7.7937 13.2865 7.70031C13.3243 7.60692 13.3804 7.52209 13.4516 7.45087C13.5228 7.37965 13.6077 7.32351 13.7011 7.28579C13.7945 7.24807 13.8945 7.22954 13.9952 7.23132C14.0959 7.23309 14.1952 7.25514 14.2872 7.29613C14.3792 7.33712 14.462 7.39622 14.5307 7.46991L18.5307 11.4699C18.6711 11.6105 18.75 11.8012 18.75 11.9999C18.75 12.1987 18.6711 12.3893 18.5307 12.5299L14.5307 16.5299C14.462 16.6036 14.3792 16.6627 14.2872 16.7037C14.1952 16.7447 14.0959 16.7667 13.9952 16.7685C13.8945 16.7703 13.7945 16.7518 13.7011 16.714C13.6077 16.6763 13.5228 16.6202 13.4516 16.549C13.3804 16.4778 13.3243 16.393 13.2865 16.2996C13.2488 16.2062 13.2303 16.1062 13.2321 16.0055C13.2338 15.9048 13.2559 15.8055 13.2969 15.7135C13.3379 15.6215 13.397 15.5387 13.4707 15.4699L16.1907 12.7499H6C5.80109 12.7499 5.61032 12.671 5.46967 12.5303C5.32902 12.3897 5.25 12.1989 5.25 11.9999C5.25 11.801 5.32902 11.6103 5.46967 11.4696C5.61032 11.329 5.80109 11.2499 6 11.2499H16.1907L13.4707 8.52991Z"
                      fill="white"
                    />
                  </svg>
                </span>
              </>
            )}
          </button>
        </div> */}
      </div>
    </>
  );
};

export default MomentDetail;
